import * as XLSX from 'xlsx';

/**
 * Hook personalizado para manejar la exportación a Excel
 */
export const useExcelExport = () => {
  /**
   * Exporta datos a un archivo Excel
   * @param {Array} data - Datos a exportar
   * @param {string} filename - Nombre del archivo (sin extensión)
   * @param {string} sheetName - Nombre de la hoja (opcional)
   */
  const exportToExcel = (data, filename, sheetName = 'Datos') => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      XLSX.writeFile(workbook, `${filename}.xlsx`);

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      throw new Error('Error al exportar el archivo Excel');
    }
  };

  /**
   * Exporta múltiples hojas a un archivo Excel
   * @param {Array} sheets - Array de objetos con { data, name }
   * @param {string} filename - Nombre del archivo
   */
  const exportMultipleSheets = (sheets, filename) => {
    try {
      const workbook = XLSX.utils.book_new();

      sheets.forEach((sheet) => {
        const worksheet = XLSX.utils.json_to_sheet(sheet.data);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
      });

      XLSX.writeFile(workbook, `${filename}.xlsx`);

    } catch (error) {
      console.error('Error exporting multiple sheets to Excel:', error);
      throw new Error('Error al exportar el archivo Excel con múltiples hojas');
    }
  };

  return {
    exportToExcel,
    exportMultipleSheets,
  };
};
